import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const RiskManagementPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  riskManagerContact,
  healthSafetyOfficerContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Risk_Management_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Risk Management Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to identifying, assessing, and managing risks effectively to protect employees, assets, customers, and the environment.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all business operations, including transport, maintenance, administration, and health & safety activities.
      </p>

      <h4 className="section-title">3. Risk Identification</h4>
      <p className="section-content">
        Risks will be identified through regular inspections, audits, incident reports, and employee feedback.
      </p>

      <h4 className="section-title">4. Risk Assessment and Evaluation</h4>
      <p className="section-content">
        Identified risks will be assessed based on likelihood and severity using a standard risk matrix to prioritise mitigation actions.
      </p>

      <h4 className="section-title">5. Risk Control and Mitigation</h4>
      <ul>
        <li>Implement controls following the hierarchy: elimination, substitution, engineering controls, administrative controls, and personal protective equipment (PPE).</li>
        <li>Develop and maintain safe working procedures and training programmes.</li>
        <li>Ensure clear communication of risk controls to all affected personnel.</li>
      </ul>

      <h4 className="section-title">6. Roles and Responsibilities</h4>
      <p className="section-content"><strong>Risk Manager:</strong> Oversees the risk management process, updates risk registers, and reports to senior management. Contact: {riskManagerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>Health & Safety Officer:</strong> Assists in hazard identification and risk assessment. Contact: {healthSafetyOfficerContact || "[Insert Contact]"}</p>
      <p className="section-content"><strong>All Employees:</strong> Responsible for reporting hazards and following risk control measures.</p>

      <h4 className="section-title">7. Monitoring and Review</h4>
      <p className="section-content">
        The risk management process will be regularly reviewed and updated to reflect changes in operations, legislation, and technology.
      </p>

      <h4 className="section-title">8. Incident Reporting</h4>
      <p className="section-content">
        All incidents and near misses must be reported promptly to ensure risks are identified and addressed.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I confirm that I have read, understood, and will comply with the Risk Management Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default RiskManagementPolicy;
